import { useEffect, useState } from "react";
import IsLogin from "../../utilities/functions/isLogin";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Places from "../../assets/images/MainPage/Places.svg";
import Departments from "../../assets/images/MainPage/Departments.svg";
import Doctors from "../../assets/images/MainPage/Doctors.svg";
import MyTurns from "../../assets/images/MainPage/MyTurns.svg";
import Turns from "../../assets/images/MainPage/Turns.svg";
import serverConfig from "../../utilities/serverConfig.json";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";
import haveAccess from "../../utilities/functions/haveAccess";
import apiConfig from "../../utilities/apiConfig.json";
import axios from "axios";


const MainPage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false)
  const { token, roles } = useSelector((state) => state.user);

  const tokenLocal = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + (token ? token : tokenLocal), };

  // check login effect
  useEffect(() => {

    const checkLoginStatus = async () => {

      setLoading(true);

      try {

        const loggedIn = await IsLogin();

        if (!token && tokenLocal) {
          dispatch(setUser({ token: tokenLocal, roles: loggedIn }));
        }

        setLoading(false);

      } catch (error) { console.error("Error checking login status:", error) }
    };

    checkLoginStatus();

  }, []);

  useEffect(() => {

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const referrer_id = params.get('st');

    if (referrer_id) localStorage.setItem('referrer_id', referrer_id)

  }, [window.location.href]);

  useEffect(() => {

    const fetchParamsAndSendRequest = async () => {

      const query = new URLSearchParams(window.location.search);
      const params = {};

      query.forEach((value, key) => { params[key] = value });
      params.gateway = 'sep';

      const hasParams = Object.keys(params).length > 1;

      if (hasParams) {

        let paramsWithoutSt = { ...params };

        if ('st' in paramsWithoutSt) {
          delete paramsWithoutSt.st
        }

        try {

          const response = await axios.post(
            `${serverConfig.server.url + apiConfig.api.addAPIs.sendDataToPaymentParams}`,
            paramsWithoutSt,
            { headers } // Make sure 'headers' is defined
          );

          // Set the response data to state
          const eventId = response.data?.data?.event_id;
          eventId && navigate(`/turn?id=${eventId}`);

        } catch (error) { console.error('Error sending payment verification request:', error); }

      }

    };

    fetchParamsAndSendRequest();

  }, [window.location.search])

  return (
    <div className="d-flex justify-content-center pt-3">
      <div className="d-flex row g-lg-4 g-3 justify-content-center">
        {
          // haveAccess(roles, "main_add_secretary")
          // false && (
          //   <div className="col-auto">
          //     <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
          //       <div className="text-decoration-none w-100" href="/">
          //         <CardActionArea className="main-page-card shadow-none">
          //           <CardMedia
          //             component="img"
          //             height="40"
          //             image={AddSecretary}
          //             className="object-fit-fill"
          //             alt="green iguana"
          //           />
          //           <CardContent className="p-0 mt-2">
          //             <Typography
          //               gutterBottom
          //               component="div"
          //               className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
          //             >
          //               ثبت‌نام منشی
          //             </Typography>
          //           </CardContent>
          //         </CardActionArea>
          //       </div>
          //     </Card>
          //   </div>
          // )
        }

        <div className="col-auto">
          <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
            <div
              className="w-100"
              onClick={() => {
                navigate("/place-store");
              }}
            >
              <CardActionArea className="main-page-card p-2">
                <CardMedia
                  component="img"
                  height="40"
                  image={Places}
                  className="object-fit-fill"
                  alt="green iguana"
                />
                <CardContent className="p-0 mt-2">
                  <Typography
                    gutterBottom
                    component="div"
                    className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                  >
                    مراکز درمانی
                  </Typography>
                </CardContent>
              </CardActionArea>
            </div>
          </Card>
        </div>

        {haveAccess(roles, "main_departments") && (
          <div className="col-auto">
            <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
              <div
                className="w-100"
                onClick={() => {
                  navigate("/department-store");
                }}
              >
                <CardActionArea className="main-page-card p-2">
                  <CardMedia
                    component="img"
                    height="40"
                    image={Departments}
                    className="object-fit-fill"
                    alt="green iguana"
                  />
                  <CardContent className="p-0 mt-2">
                    <Typography
                      gutterBottom
                      component="div"
                      className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                    >
                      دپارتمان ها
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
          </div>
        )}
        <div className="col-auto">
          <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
            <div
              className="w-100"
              onClick={() => {
                navigate("/doctor-store");
              }}
            >
              <CardActionArea className="main-page-card p-2">
                <CardMedia
                  component="img"
                  height="40"
                  image={Doctors}
                  className="object-fit-fill"
                  alt="green iguana"
                />
                <CardContent className="p-0 mt-2">
                  <Typography
                    gutterBottom
                    component="div"
                    className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                  >
                    پزشکان
                  </Typography>
                </CardContent>
              </CardActionArea>
            </div>
          </Card>
        </div>
        {haveAccess(roles, "main_my_turns") && (
          <div className="col-auto">
            <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
              <div
                className="w-100"
                onClick={() => {
                  navigate("/my-turns");
                }}
              >
                <CardActionArea className="main-page-card p-2">
                  <CardMedia
                    component="img"
                    height="40"
                    image={MyTurns}
                    className="object-fit-fill"
                    alt="green iguana"
                  />
                  <CardContent className="p-0 mt-2">
                    <Typography
                      gutterBottom
                      component="div"
                      className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                    >
                      نوبت‌های من
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
          </div>
        )}

        {haveAccess(roles, "main_turns") && (
          <div className="col-auto">
            <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
              <div
                className="w-100"
                onClick={() => {
                  navigate("/turns");
                }}
              >
                <CardActionArea className="main-page-card py-2">
                  <CardMedia
                    component="img"
                    height="40"
                    image={Turns}
                    className="object-fit-fill"
                    alt="green iguana"
                  />
                  <CardContent className="p-0 mt-2">
                    <Typography
                      gutterBottom
                      component="div"
                      className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                    >
                      نوبت‌های مراجعین
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
          </div>
        )}
        {/* {haveAccess(roles, "main_shift_show") && (
          <div className="col-auto">
            <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
              <div
                className="w-100"
                onClick={() => {
                  navigate("/");
                }}
              >
                <CardActionArea className="main-page-card p-2">
                  <CardMedia
                    component="img"
                    height="40"
                    image={DoctorsShifts}
                    className="object-fit-fill"
                    alt="green iguana"
                  />
                  <CardContent className="p-0 mt-2">
                    <Typography
                      gutterBottom
                      component="div"
                      className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                    >
                      شیفت‌های پزشکان
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
          </div>
        )} */}
        {/* {haveAccess(roles, "main_vacations") && (
          <div className="col-auto">
            <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
              <div
                className="w-100"
                onClick={() => {
                  navigate("/");
                }}
              >
                <CardActionArea className="main-page-card p-2">
                  <CardMedia
                    component="img"
                    height="40"
                    image={Vacations}
                    className="object-fit-fill"
                    alt="green iguana"
                  />
                  <CardContent className="p-0 mt-2">
                    <Typography
                      gutterBottom
                      component="div"
                      className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                    >
                      ثبت و مشاهده مرخصی‌ها
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
          </div>
        )} */}
        {/* {haveAccess(roles, "main_create_qr") && (
          <div className="col-auto">
            <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
              <div
                className="w-100"
                onClick={() => {
                  navigate("/");
                }}
              >
                <CardActionArea className="main-page-card p-2">
                  <CardMedia
                    component="img"
                    height="40"
                    image={ScanQRcode}
                    className="object-fit-fill"
                    alt="green iguana"
                  />
                  <CardContent className="p-0 mt-2">
                    <Typography
                      gutterBottom
                      component="div"
                      className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                    >
                      ساخت QR Code
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </div>
            </Card>
          </div>
        )} */}
        {/* <div className="col-auto">
          <Card className="main-page-card d-flex align-items-center border-radius-8 border-gray-200">
            <div
              className="w-100"
              onClick={() => {
                navigate("/");
              }}
            >
              <CardActionArea className="main-page-card p-2">
                <CardMedia
                  component="img"
                  height="40"
                  image={CitiesProvinces}
                  className="object-fit-fill"
                  alt="green iguana"
                />
                <CardContent className="p-0 mt-2">
                  <Typography
                    gutterBottom
                    component="div"
                    className="fs-12 fw-bold color-bootstrap-gray-800 text-center"
                  >
                    شهرها / استان‌ها
                  </Typography>
                </CardContent>
              </CardActionArea>
            </div>
          </Card>
        </div> */}

        {loading && (
          <div className="d-flex row justify-content-center mt-3">
            <span
              className="spinner-border spinner-border"
              role="status"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MainPage;
